import {BaseModel, type Brand, RoleEnum, type Role} from './application';

export interface User extends BaseModel {
  name?: string;
  email: string
  password?: string;
  phone?: string;
  document?: string;
  status: UserStatus;
  brand: Brand;
  roles: Role[];
  utm_afiliados_id?: string | null;
}

export interface CreateUserPayload {
  name?: string;
  email: string
  password?: string;
  phone?: string;
  document?: string;
  role?: RoleEnum | string | null;
  status?: UserStatus;
  brand: Brand;
  utm_afiliados_id?: string | null;
}

export interface FinalizeUserPayload {
  name: string;
  password: string;
  phone: string;
  document: string;
}

export interface UpdateUserPayload extends Partial<CreateUserPayload> {}

export enum UserStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface AnalyticsUser {
  id: number;
  name: string;
  password: string;
  email?: string;
  phone?: string;
  // role: EnumRole;
  mark: Brand;
  // status: EnumStatus;
  created_at: Date;
  has_dashboard_access: boolean;
  profile_image?: string;
}

export interface RecoverPassword {
  email: string
}

export interface ResetPassword {
  password: string
}
